




import { Component, Prop, Vue } from "vue-property-decorator";

let count = 0;

@Component
export default class TableJSON extends Vue {
  @Prop() public value: any;

  get items() {
    return this.buildItems(this.value);
  }

  public buildItems(from: any) {
    const vals: any = [];
    for (const k in from) {
      if (!from.hasOwnProperty(k)) {
        continue;
      }
      const v: any = {
        id: count++,
        name: k
      };
      if (typeof from[k] === "object") {
        v.children = this.buildItems(from[k]);
      } else {
        v.name = v.name + ": " + from[k];
      }
      vals.push(v);
    }
    return vals;
  }
}
